import {SettingsIcon} from "lucide-react";
import Icon from "@/components/icon";
import {BreadcrumbProvider, type Breadcrumb} from "@/features/breadcrumbs";

export const breadcrumb: Breadcrumb =
{
    dirname: __dirname,
    title: "Settings",
    icon: <Icon component={SettingsIcon} />,
};

export default function Layout({children}: Readonly<{children: React.ReactNode}>)
{
    return (
        <BreadcrumbProvider {...breadcrumb}>
            {children}
        </BreadcrumbProvider>
    );
}
